import React from 'react'

import Loader from './loader'
import Pagination from './crud_pagination'
import SortableColumn from './crud_list_sortable_column'
import Title from './crud_title'

class CRUDList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isLoading: true,
      page: 1
    }

    this.onNewPage = this.onNewPage.bind(this)
    this.onClickDetails = this.onClickDetails.bind(this)
  }

  componentWillMount () {
    if (this.props.resources) {
      this.initiateResources(this.props.resources)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.resources !== nextProps.resources) {
      this.initiateResources(nextProps.resources)
    }

    if (this.props.isLoading !== nextProps.isLoading) {
      this.setState({
        isLoading: nextProps.isLoading
      })
    }
  }

  initiateResources (resources) {
    this.setState({isLoading: false})
    this.loadCurrentPage(resources)
  }

  loadCurrentPage (resources, page) {
    resources = resources || this.props.resources
    page = page || this.state.page

    const start = this.props.limit * (page - 1)
    const end = start + this.props.limit

    const pageResources = resources.slice(start, end)

    this.setState({pageResources})
  }

  calculateTotal () {
    if (this.props.isResourceSearchBased) {
      return this.props.totalRecords || 0
    }
    else {
      return this.props.resources ? this.props.resources.size : 0
    }
  }

  onNewPage (page) {
    this.setState({page})

    if (this.props.isResourceSearchBased) {
      this.props.onNewPage(page)
    }
    else {
      this.loadCurrentPage(this.props.resources, page)
    }
  }

  onClickDetails (resource, e) {
    if (e && e.preventDefault) e.preventDefault()

    this.props.onSwitchToDetail(resource)
  }

  renderAttributeHeader (attr) {
    let item = attr.label
    let width

    if (attr.headerFormatter) return attr.headerFormatter()
    if (attr.isBold && !attr.isSortable) item = <b>{item}</b>

    if (attr.isSortable) {
      item = (
        <SortableColumn
          name={attr.name} label={attr.label}
          onSortChange={this.props.onSortChange}/>
      )
    }

    if (attr.isPrimary) width = '100%'
    else if (attr.width) width = attr.width

    return <th key={attr.name} className={attr.name} style={{width}}>{item}</th>
  }

  renderResourceActionsHeader () {
    if (this.props.isActionsEnabled) {
      return (
        <th>Actions</th>
      )
    }
  }

  renderHeader () {
    return (
      <thead>
        <tr>
          {
            this.props.attrs.map((attr) => this.renderAttributeHeader(attr))
          }
          {this.renderResourceActionsHeader()}
        </tr>
      </thead>
    )
  }

  renderResourceAttribute (resource, attr) {
    let item = resource.get(attr.name)

    if (attr.formatter) item = attr.formatter(item, resource)
    if (attr.prefix) item = attr.prefix + item
    if (attr.isBold) item = <b>{item}</b>

    return <td key={attr.name}>{item}</td>
  }

  renderResourceAttributes (resource) {
    return this.props.attrs.map((attr) => this.renderResourceAttribute(resource, attr))
  }

  renderCustomAction (resource, key) {
    if (this.props.customAction) {
      return this.props.customAction(resource, key)
    }
  }

  renderActionDetails (resource) {
    if (this.props.isActionDetailsEnabled) {
      return (
        <a href='#' className='btn btn-default' onClick={(e) => this.onClickDetails(resource, e)}>Details</a>
      )
    }
  }

  renderResourceActions (resource, key) {
    if (this.props.isActionsEnabled) {
      return (
        <td>
          <div className='resource-row-actions'>
            {this.renderCustomAction(resource, key)}
            {this.renderActionDetails(resource)}
          </div>
        </td>
      )
    }
  }

  renderBody () {
    const pageResources = this.props.isResourceSearchBased ? this.props.resources : this.state.pageResources

    if (this.props.resources && pageResources) {
      return (
        <tbody>
          {
            pageResources.map((resource, key) => {
              return (
                <tr key={key || resource.get('key')} className={this.props.rowClassName}>
                  {this.renderResourceAttributes(resource)}
                  {this.renderResourceActions(resource, key)}
                </tr>
              )
            })
          }
        </tbody>
      )
    }
  }

  renderTitle () {
    if (this.props.title) {
      return (
        <Title title={this.props.title}/>
      )
    }
  }

  render () {
    return (
      <div className='crud-list table-responsive' style={{position: 'relative'}}>
        <Loader loading={this.state.isLoading}/>
        {this.renderTitle()}
        <table className='table table-hover'>
          {this.renderHeader()}
          {this.renderBody()}
        </table>
        <div style={{textAlign: 'center'}}>
          <Pagination
            total={this.calculateTotal()}
            currentPage={this.state.page}
            limitPerPage={this.props.limit}
            onNewPage={this.onNewPage}
            style={this.props.paginationStyle}>
          </Pagination>
        </div>
      </div>
    )
  }
}

CRUDList.defaultProps = {
  limit: 20,
  isActionsEnabled: false,
  isActionDetailsEnabled: true,
  onSwitchToDetail: () => {},
  onNewPage: () => {}
}

export default CRUDList



/** WEBPACK FOOTER **
 ** ./modules/shared/crud_list.js
 **/